<template>
  <div class="row">
    <div class="col-xxl-12">
      <div class="module-tabs mb-20">
        <button
          type="button"
          class="module-tab"
          :class="{ active: activeTab === 'sales' }"
          @click="activeTab = 'sales'"
        >
          <i class="ph ph-shopping-cart"></i>
          Vendas
        </button>
        <button
          type="button"
          class="module-tab"
          :class="{ active: activeTab === 'reports' }"
          @click="activeTab = 'reports'"
        >
          <i class="ph ph-chart-line-up"></i>
          Relatórios
        </button>
      </div>

      <SalesList v-if="activeTab === 'sales'" />
      <SalesReportsTab v-else />
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import SalesList from "../../components/Sales/SalesList.vue";
import SalesReportsTab from "../../components/Sales/SalesReportsTab.vue";

export default defineComponent({
  name: "SalesPage",
  data() {
    return {
      activeTab: 'sales'
    };
  },
  components: {
    SalesList,
    SalesReportsTab
  },
});
</script>

<style scoped>
.module-tabs {
  background: #ffffff;
  border-radius: 7px;
  box-shadow: 0 4px 18px rgba(47, 49, 82, 0.06);
  display: inline-flex;
  gap: 8px;
  padding: 8px;
}

.module-tab {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: #6b7280;
  display: inline-flex;
  font-weight: 600;
  gap: 8px;
  min-height: 42px;
  padding: 0 18px;
  transition: 0.2s ease;
}

.module-tab.active {
  background: #00b894;
  color: #ffffff;
}

@media (max-width: 575.98px) {
  .module-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .module-tab {
    justify-content: center;
    padding: 0 10px;
  }
}
</style>
